/**
 * Regras de dimensão da logo da transportadora.
 * Espelhadas no backend (`TransportCompanyLogoValidator`).
 */
export const TRANSPORT_COMPANY_LOGO_RULES = {
    minWidth: 320,
    maxWidth: 1200,
    minHeight: 80,
    maxHeight: 400,
    minAspect: 2.0,
    maxAspect: 5.0,
    maxDelta: 2,
    maxBytes: 1024 * 1024,
    referenceWidth: 640,
    referenceHeight: 225,
};

export const TRANSPORT_COMPANY_LOGO_FORMATS = {
    PNG: 'PNG',
    SVG: 'SVG',
};

export const TRANSPORT_COMPANY_LOGO_TTL_MS = 3600 * 1000;

export const PNG_MAGIC_BYTES = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
